export default __webpack_public_path__ + "static/EAO-SPBR_synopsis-V2-bd90bc85cbef2cf460f482c53ba395d7.pdf";